import React from "react";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "./FieldSettingsView";
import { DisplaySettings } from "./shared/DisplaySettings";
import { FieldPermissionsConfig } from "./shared/FieldPermissionsConfig";
import { FieldSettingsConfig } from "./shared/FieldSettingsConfig";
import { PlaceholderTextInput } from "./shared/PlaceholderTextInput";

export function DamageDegreeWidgetSettings({
  fieldPath,
  isReadOnly,
}: InputSettingsFormProps) {
  return (
    <WidgetSettingsContainer>
      {/* This should always be a module input */}
      <FieldSettingsConfig
        fieldPath={fieldPath}
        isModuleInput={true}
        isFormulaField={false}
        isReadOnly={isReadOnly}
      />
      <PlaceholderTextInput fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <FieldPermissionsConfig fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <DisplaySettings fieldPath={fieldPath} isReadOnly={isReadOnly} />
    </WidgetSettingsContainer>
  );
}
